module.exports = __webpack_public_path__ + "img/Nybygg.584dbeb1.jpg";